export default "__VITE_ASSET__CWw8xF58__"